import TableNavigationItem from "./TableNavigationItem";
import TableNavigationItemNext from "./TableNavigationItemNext";
import TableNavigationItemPrevious from "./TableNavigationItemPrevious";


function TableNavigation({ page, totalPages, goToPage }) {

  if (totalPages === '1') {
    return;
  }

  return (
    <nav className="small-pagination pt-2">
      <ul>
        
        <TableNavigationItemPrevious 
          className="small-pagination__arrow small-pagination__prev" 
          page={page} 
          goToPage={goToPage} 
        />

        {Array.from({ length: totalPages }, (_, item) => {
          const pageNumber = item + 1;
          return <TableNavigationItem key={item} page={page} pageNumber={pageNumber} goToPage={goToPage} />
          })}

        <TableNavigationItemNext 
          className="small-pagination__arrow small-pagination__next"
          totalPages={totalPages} 
          page={page} 
          goToPage={goToPage} 
        />

      </ul>
    </nav>
  )
}

export default TableNavigation